import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/pages/_notFound.scss';

function PageNotFound ({ className }) {
  // useEffect(() => {
  //   loader && startLoader();
  // }, []);
  return (
        <div className={`notFound_page ${className && className}`}>
            <Link to='/' className='banner-logo'>
                <img src='/media/images/InClassicaColorLogo.png' alt='logo' />
            </Link>

            <div className='notFound_body'>
                <div>
                    <div className='notFound_banner'>
                        <div className='notFound_404'>
                            <div className='notFound_404_1'>4</div>
                            <div className='notFound_404_2'>0</div>
                            <div className='notFound_404_3'>4</div>
                        </div>
                        <p className='notFound_notification'>
                            <span>We couldn't find this page.</span>
                        </p>
                    </div>
                </div>
                <div className='notFound_links'>
                    <p className='notFound_links_title'>
                            <span>
                                Maybe this links can help you
                            </span>
                    </p>
                    <ul>
                        <li>
                            <Link to='/about'>
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link to='/contact'>
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <Link to='/faq'>
                                FAQ
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
  );
}
export default memo(PageNotFound);
